<section class="section-div">
  <div class="header-div">
    <h4><ion-icon name="megaphone-outline"></ion-icon> Infrastructure</h4>
  </div>
  <div class="content-details">
    <div class="content-div mb-2">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12" [formGroup]="hrForm">
          <mat-accordion>
            <!-- qusetion 001 upload09 -->
            <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
              <mat-expansion-panel-header class="d-flex">
                <h6>01.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Built-up area (in sq ft) to be provided for the StartupTN
                    Pre-Incubation Centre<br />
                    (Minimum 3,000 sq ft space to be allocated) </span
                  ><span class="text-danger">*</span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="row">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Built-up area (in sq ft) to be provided for the StartupTN
                      Pre-Incubation Centre<br />
                      (Minimum 3,000 sq ft space to be allocated )<span
                        class="text-danger"
                        >*</span
                      >
                    </h6>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="form-rows">
                      <mat-form-field
                        class="material-full-width"
                        appearance="outline"
                      >
                        <mat-label
                          >Incubation Space
                          <span class="text-danger">*</span></mat-label
                        >
                        <input
                          matInput
                          placeholder="Enter Incubation Space"
                          type="text"
                          readonly="{{ showForm }}"
                          formControlName="incubationspace"
                        />
                        <mat-error
                          *ngIf="
                            hrForm.get('incubationspace').hasError('required')
                          "
                        >
                          Incubation Space
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="form-rows">
                      <mat-form-field
                        class="material-full-width"
                        appearance="outline"
                      >
                        <mat-label
                          >Co-working Space / Capacity (Seater)
                          <span class="text-danger">*</span></mat-label
                        >
                        <input
                          matInput
                          placeholder="Enter Co-working Space / Capacity (Seater)"
                          type="text"
                          readonly="{{ showForm }}"
                          formControlName="coworkingspace"
                        />
                        <mat-error
                          *ngIf="
                            hrForm.get('coworkingspace').hasError('required')
                          "
                        >
                          Co-working Space / Capacity (Seater) is required
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="form-rows">
                      <mat-form-field
                        class="material-full-width"
                        appearance="outline"
                      >
                        <mat-label
                          >Meeting Room Space / Capacity (Seater)
                          <span class="text-danger">*</span></mat-label
                        >
                        <input
                          matInput
                          placeholder="Enter Meeting Room Space  / Capacity (Seater)"
                          type="text"
                          readonly="{{ showForm }}"
                          formControlName="meetingroom"
                        />
                        <mat-error
                          *ngIf="hrForm.get('meetingroom').hasError('required')"
                        >
                          Meeting Room Space / Capacity (Seater) is required
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sm-6 col-12">
                    <div class="form-rows">
                      <mat-form-field
                        class="material-full-width"
                        appearance="outline"
                      >
                        <mat-label
                          >Maker Space
                          <span class="text-danger">*</span></mat-label
                        >
                        <input
                          matInput
                          placeholder="Enter Maker Space"
                          type="text"
                          readonly="{{ showForm }}"
                          formControlName="makerspace"
                        />
                        <mat-error
                          *ngIf="hrForm.get('makerspace').hasError('required')"
                        >
                          Makerspace is required
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row *ngIf="!showForm">
                <button mat-button color="primary" (click)="nextStep()">
                  Save & Continue
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 003 -->
            <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
              <mat-expansion-panel-header class="d-flex title_dco">
                <h6>02.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false"
                    >Details of technical supporting facilities like Testing,
                    Prototyping, Research & Development, etc.
                    (Non-Academic)<span class="text-danger">*</span>
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
              </mat-expansion-panel-header>
              <div class="answer-div">
                <div class="">
                  <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                    <h6>
                      Details of technical supporting facilities like Testing,
                      Prototyping, Research & Development, etc. (Non-Academic)
                    </h6>
                  </div>
                  <div class="content-details">
                    <div class="row">
                      <div
                        class="col-12 mb-3"
                        *ngIf="!showForm && 4 >= facility.length"
                      >
                        <button
                          class="btn btn-primary"
                          style="float: inline-end"
                          (click)="addRow()"
                        >
                          Add Facility
                        </button>
                      </div>
                      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                        <div class="table-responsive" [formGroup]="hrForm">
                          <table class="table table-bordered">
                            <thead class="thead-light">
                              <tr>
                                <th scope="col">No</th>
                                <th scope="col">Name of the Facility</th>
                                <th scope="col">Space (in sqft)</th>
                                <th scope="col">Available Equipments</th>
                                <th
                                  scope="col"
                                  class="text-center"
                                  *ngIf="!showForm"
                                >
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                *ngFor="
                                  let item of facility.controls;
                                  let i = index
                                "
                                [formGroup]="item"
                              >
                                <th scope="row">{{ i + 1 }}</th>

                                <td>
                                  <input
                                    class="form-control"
                                    [readonly]="showForm"
                                    formControlName="facilityname"
                                    [ngClass]="{
                                      'is-invalid':
                                        item.get('facilityname').touched &&
                                        item.get('facilityname').errors
                                    }"
                                    type="text"
                                    placeholder="Name of the Facility"
                                  />
                                  <div
                                    *ngIf="
                                      item.get('facilityname').touched &&
                                      item.get('facilityname').errors
                                    "
                                  >
                                    <span
                                      class="text-danger"
                                      *ngIf="
                                        item.get('facilityname').errors.required
                                      "
                                    >
                                      facilityname is required
                                    </span>
                                  </div>
                                </td>

                                <td>
                                  <input
                                    class="form-control"
                                    formControlName="space"
                                    [readonly]="showForm"
                                    [ngClass]="{
                                      'is-invalid':
                                        item.get('space').touched &&
                                        item.get('space').errors
                                    }"
                                    type="text"
                                    placeholder="Enter Space (in sqft)"
                                  />
                                  <div
                                    *ngIf="
                                      item.get('space').touched &&
                                      item.get('space').errors
                                    "
                                  >
                                    <span
                                      class="text-danger"
                                      *ngIf="item.get('space').errors.required"
                                    >
                                      Space (in sqft) is required
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <input
                                    class="form-control"
                                    formControlName="availableinstruments"
                                    [readonly]="showForm"
                                    [ngClass]="{
                                      'is-invalid':
                                        item.get('availableinstruments')
                                          .touched &&
                                        item.get('availableinstruments').errors
                                    }"
                                    type="text"
                                    placeholder="Enter Available Equipments "
                                  />
                                  <div
                                    *ngIf="
                                      item.get('availableinstruments')
                                        .touched &&
                                      item.get('availableinstruments').errors
                                    "
                                  >
                                    <span
                                      class="text-danger"
                                      *ngIf="
                                        item.get('availableinstruments').errors
                                          .required
                                      "
                                    >
                                      Available Equipments is required
                                    </span>
                                  </div>
                                </td>
                                <td class="text-center" *ngIf="!showForm">
                                  <i
                                    class="fas fa-trash delete-i ml-3"
                                    (click)="deleteRow(i, item.get('id').value)"
                                    aria-hidden="true"
                                  ></i>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row *ngIf="!showForm">
                <button mat-button color="warn" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Save
                </button>
              </mat-action-row>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</section>
